/**
 * Type is declared here because canonical source metadata is owned by Cloud
 * policy data rather than imported from the legacy govern package.
 */
export type CanonicalSource =
  | {
      kind: 'npm';
      specifier: string;
      exclude?: string[];
    }
  | {
      kind: 'directory';
      path: string;
      exclude?: string[];
    };

/**
 * Returns an `npm` source seeded from the org's canonical design-system
 * binding, or null when no package name is available.
 */
export function deriveCanonicalSource(
  canonicalPackageName: string | null,
): CanonicalSource | null {
  if (!canonicalPackageName) return null;
  return { kind: 'npm', specifier: canonicalPackageName };
}
